import {NgModule} from '@angular/core';
import {InternalImpactPointComponent} from '@shared/components/internal-impact-point/internal-impact-point.component';
import {CommonModule} from '@angular/common';
import {InternalImpactPointSectionComponent} from './internal-impact-point-section/internal-impact-point-section.component';
import {InternalImpactPointSeatComponent} from './internal-impact-point-seat/internal-impact-point-seat.component';
import {InternalImpactPointColumnComponent} from './internal-impact-point-column/internal-impact-point-column.component';
import {InternalImpactPointService} from '@shared/components/internal-impact-point/internal-impact-point.service';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        InternalImpactPointComponent,
        InternalImpactPointSectionComponent,
        InternalImpactPointSeatComponent,
        InternalImpactPointColumnComponent
    ],
    exports: [
        InternalImpactPointComponent
    ],
    providers: [
        InternalImpactPointService
    ]
})
export class InternalImpactPointModule {
}
